export default __webpack_public_path__ + "static/media/parmjit.d71fa387.jpg";